import { shallowEqual, useSelector } from 'react-redux';
import { getPayoutOrder } from '../../selectors';

export const useOrder = () => ({
  order: useSelector(getPayoutOrder, shallowEqual),
});
